module.exports = __webpack_public_path__ + "img/weidian.10cd0786.png";